import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from '../../../../services/common/common-field.service';
import {InternalTradeOrderViewService} from '../../../../services/internal/internal-trade-order-view.service';
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../model/api/api-validation";
import {TableButtonConfig} from "../../../../model/api/table-button-config";
import {ClearingAllocationService} from "../../../../services/clearing/clearing-allocation.service";
import {ClearingAllocationTaskService} from "../../../../services/clearing/clearing-allocation-task.service";
import {ViewConfig} from "../../../../model/api/view-config";
import {DatePipe, DecimalPipe} from "@angular/common";
import {ThemeService} from "../../../../services/tools/theme.service";
import {AppConfigService} from "../../../../services/app-config.service";
import {CCRolesType} from "../../../../model/security/cc-roles-type";
import {ClearingTableBaseWsComponent} from "../clearing-table-base-ws.component";
import {ClearingOrderWsService} from "../../../../services/clearing/ws/clearing-order-ws.service";
import {ClearingTableConfigService} from "../../../../services/clearing/clearing-table-config.service";
import {ClearingCookieService} from "../../../../services/clearing/clearing-cookie-service";
import {ClearingSelectionService} from "../../../../services/clearing/clearing-selection.service";
import {ClearingTableSyncWsService} from "../../../../services/clearing/ws/clearing-table-sync-ws.service";

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTableBaseComponent extends ClearingTableBaseWsComponent {

  transPartKey: string = 'clearing.order';

  // table
  headerButtonConfig: TableButtonConfig[] = [];
  tableContextMenuConfig: MenuItem[] = [];

  formRecord: any;

  protected orderReferenceColorMap = {};

  constructor(cdref: ChangeDetectorRef,
              protected allocationService: ClearingAllocationService,
              allocationTaskService: ClearingAllocationTaskService,
              protected commonFieldService: CommonFieldService,
              protected userViewService: InternalTradeOrderViewService,
              appConfigService: AppConfigService,
              clearingOrderWsService: ClearingOrderWsService,
              messageService: MessageService,
              protected confirmationService: ConfirmationService,
              translateService: TranslateService,
              public themeService: ThemeService,
              public tableConfigService: ClearingTableConfigService,
              protected clearingCookieService: ClearingCookieService,
              protected clearingTableSyncWsService: ClearingTableSyncWsService,
              protected clearingSelectionService: ClearingSelectionService) {
    super(cdref, messageService, confirmationService, appConfigService, clearingOrderWsService, translateService,
      commonFieldService, allocationTaskService, allocationService,
      themeService, tableConfigService, clearingCookieService, clearingTableSyncWsService,
      clearingSelectionService);
    userViewService.clearStorage();
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();

    this.themeService.isDarkThemeChange.subscribe(value => {
      this.orderReferenceColorMap = {};
      this.clearReloadTable(this.tableCurrentRequest);
    });
  }

  public initConfigs() {
    super.initConfigs();
  }

  public refreshTable() {

    if (this.appConfigService.clearingAllocationEnabled)
      this.refreshButtons();

    super.refreshTable();
    if (!this.tableConfig) {
      return;
    }
    let configToAdjust = this.tableConfig.find(value => value.field === 'reference');
    if (configToAdjust) {
      configToAdjust.style = (record: any) => {
        const reference = this.getOrderReference(record);
        if (!this.orderReferenceColorMap[reference]) {
          if (this.themeService.isDarkTheme)
            this.orderReferenceColorMap[reference] = this.generateLightColorHex();
          else
            this.orderReferenceColorMap[reference] = this.generateDarkColorHex();
        }
        return 'color:' + this.orderReferenceColorMap[reference] + ' !important;';
      }
    }
  }

  protected getOrderReference(record: any) {
    return record.reference ? record.reference
      : (record.clearings && record.clearings.length > 0 && record.clearings[0].order ?
        (record.clearings[0].order.reference ? record.clearings[0].order.reference : '') : '');
  }

  protected generateDarkColorHex() {
    let color = "#";
    for (let i = 0; i < 3; i++)
      color += ("0" + Math.floor(Math.random() * Math.pow(16, 2) / 2).toString(16)).slice(-2);
    return color;
  }

  protected generateLightColorHex() {
    let color = "#";
    for (let i = 0; i < 3; i++)
      color += ("0" + Math.floor(((1 + Math.random()) * Math.pow(16, 2)) / 2).toString(16)).slice(-2);
    return color;
  }

  protected refreshButtons() {
  }

  protected getViewTemplate(): Observable<ApiValidation<ViewConfig>> {
    return this.userViewService.getOrderTemplate(this.userView.template)
  }

  checkAllocationTask(apiValidation) {
    if (apiValidation.success) {
      this.startCheckingAllocationTask(apiValidation.item)
    } else {
      this.errorMessage(apiValidation.message);
    }
  }

  protected showDetailEnabled() {
    return this.selectedIds.length == 1;
  }

  protected reversalManagementEnabled(stateAccepted: string, stateRevRequested: string) {
    if ( this.selectedIds.length <= this.appConfigService.allocationHardLimitCount
    &&this.currentClearingSelectionInfosByLeg.length > 0) {
      const exchField = this.exchanges ? this.exchanges.find(field => field.value
        && field.value.clearingHouse === this.currentClearingSelectionInfosByLeg[0].clearingHouse
        && field.value.code === this.currentClearingSelectionInfosByLeg[0].exchangeCode) : undefined;
      return exchField && exchField.value.reversalManagement
        && (this.validState(stateAccepted) || this.validState(stateRevRequested));
    }
    return false;
  }

  protected validState(state: string) {
    let requestGUReversalEnabled = this.currentClearingSelectionInfosByLeg.length > 0;
    this.currentClearingSelectionInfosByLeg.forEach(value => {
      if (requestGUReversalEnabled && value.state != state) {
        requestGUReversalEnabled = false;
      }
    });
    return requestGUReversalEnabled;
  }

  activeChanged() {
    this.active = !this.active;
    this.activeChange.emit(this.active);
    // this.refreshTable();
    // // queueMicrotask(() => this.refreshTable());
    // this.records = [];
    // this.recordIds = [];
    // this.selectedIds = [];
    // this.totalRecords = 0;
    // this.clearReloadTable(this.tableCurrentRequest);
    // // queueMicrotask(() => this.clearReloadTable(this.tableCurrentRequest));
    // this.cookieService.set(CookieNames.CLEARING_ORDER_TRADEMODE, JSON.stringify(this.tradeModeEnabled));
  }


  protected canDoReversal(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_SYSTEM, CCRolesType.Roles.ROLE_ADVANCED_CLEARER]);
  }

}
